import { Sparkles } from "lucide-react";

interface ProgressInsightCardProps {
  message: string;
}

export const ProgressInsightCard = ({ message }: ProgressInsightCardProps) => {
  if (!message) return null;

  return (
    <div className="bg-gradient-to-br from-indigo-50 to-purple-50 border border-indigo-100/50 rounded-3xl p-5 shadow-sm">
      <div className="flex gap-4">
        <div className="w-10 h-10 rounded-xl bg-white shadow-sm flex items-center justify-center shrink-0">
          <Sparkles className="h-5 w-5 text-indigo-500" />
        </div>
        <div>
          <h3 className="text-sm font-bold text-indigo-900 mb-1">Insight Inteligente</h3>
          <p className="text-sm text-indigo-800/80 leading-relaxed">
            {message}
          </p>
        </div>
      </div>
    </div>
  );
};
